import { TRANSACTION_TYPES } from '../utils/constants';

const assetsRoutes = [


    {
        path: '/assets',
        name: 'AssetsPage',
        component: () => import('@/views/assets/AssetsComponent.vue'),
        meta: {
            requiresAuth: true,
            permission: 'assets',
            module: 'risksManagement',

        }

    },

    {
        path: '/assets/create',
        name: 'AssetsCreatePage',
        component: () => import('@/views/assets/AssetsManagerComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            permission: ['assets', 'createAsset'],
            module: 'risksManagement',

        }
    },

    {
        path: '/assets/criticity/:assetId',
        name: 'AssetCriticalityPage',
        component: () => import('@/views/assets/AssetCriticalityComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: ['assets', 'viewAssetCriticity'],
            module: 'risksManagement',

        },
        props: route => ({ assetId: route.params.assetId }),

    },

    {
        path: '/assets/edit/:assetId',
        name: 'AssetsEditPage',
        component: () => import('@/views/assets/AssetsManagerComponent.vue'),
        props: route => ({ type: TRANSACTION_TYPES.EDIT, assetId: route.params.assetId }),
        meta: {
            requiresAuth: true,
            permission: ['assets', 'editAsset'],
            module: 'risksManagement',

        }
    },

    {
        path: '/assets/show/:assetId',
        name: 'AssetsShowPage',
        component: () => import('@/views/assets/AssetsManagerComponent.vue'),
        props: route => ({ type: TRANSACTION_TYPES.SHOW, assetId: route.params.assetId }),
        meta: {
            requiresAuth: true,
            permission: ['assets', 'viewAsset'],
            module: 'risksManagement',

        }
    },

    {
        path: '/assets/store/from-template',
        name: 'StoreAssetsFromTemplate',
        component: () => import('@/views/assets/AssetsFromTemplateComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: ['assets', 'viewAssetsFromTemplate'],
            module: 'risksManagement',

        },

    }
];

export default assetsRoutes;